export enum ShipmentPurpose {
  Commercial = 'shipmentPurposeOption.commercial',
  Gift = 'shipmentPurposeOption.gift',
  PersonalEffects = 'shipmentPurposeOption.personalEffects',
  PersonalUse = 'shipmentPurposeOption.personalUse',
  ReturnAndRepair = 'shipmentPurposeOption.returnAndRepair',
  Sample = 'shipmentPurposeOption.sample',
}
